<div class="asistente-fondo" (click)="cerrar.emit()"></div>

<section
  #panel
  class="asistente"
  role="dialog"
  aria-modal="true"
  aria-labelledby="asistente-titulo"
>
  <header class="cabecera">
    <div class="avatar" aria-hidden="true">A</div>
    <div class="titulo">
      <b id="asistente-titulo">Asistente Aguacate</b>
      <span>Respuestas automáticas · toca una opción</span>
    </div>
    <button type="button" class="cerrar" (click)="cerrar.emit()" aria-label="Cerrar asistente">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div #registro class="registro" aria-live="polite">
    <ng-container *ngFor="let e of entradas; trackBy: trackIndice">
      <ng-container [ngSwitch]="e.tipo">

        <div *ngSwitchCase="'bot'" class="msg bot">{{ $any(e).texto }}</div>
        <div *ngSwitchCase="'cliente'" class="msg cliente">{{ $any(e).texto }}</div>

        <div *ngSwitchCase="'saldo'" class="msg bot ancho">
          Tu saldo disponible:
          <div class="saldos">
            <div class="saldo" *ngFor="let s of $any(e).saldos">
              <span class="moneda">{{ s.moneda }}</span>
              <span class="cifra">{{ monto(s) }}</span>
            </div>
          </div>
          <span class="meta" *ngIf="$any(e).consultadoEn">Actualizado {{ fecha($any(e).consultadoEn) }}</span>
        </div>

        <div *ngSwitchCase="'operaciones'" class="msg bot ancho">
          {{ $any(e).titulo }}
          <div class="filas">
            <button
              type="button"
              class="fila tocable"
              *ngFor="let op of $any(e).lista"
              (click)="tocarOperacion(op, $any(e).paraOperador)"
              [disabled]="ocupado && !$any(e).paraOperador"
            >
              <span class="ico"><mat-icon>north_east</mat-icon></span>
              <span class="cuerpo">
                <span class="t1">{{ op.titulo }}</span>
                <span class="t2">{{ monto(op.origen) }}<ng-container *ngIf="op.destino"> → {{ monto(op.destino) }}</ng-container></span>
                <span class="t3">{{ fecha(op.fecha) }} · N.º {{ op.numero }}</span>
              </span>
              <span class="estado" [ngClass]="claseEstado(op.estado)">{{ op.estadoTexto }}</span>
            </button>
          </div>
          <span class="meta">{{ $any(e).paraOperador
            ? 'Al tocarla te abrimos WhatsApp con los datos ya escritos.'
            : 'Toca una operación para ver en qué paso va.' }}</span>
        </div>

        <div *ngSwitchCase="'detalle'" class="msg bot ancho">
          <b>{{ $any(e).op.titulo }}</b> · N.º {{ $any(e).op.numero }}
          <div class="t2">{{ monto($any(e).op.origen) }}<ng-container *ngIf="$any(e).op.destino"> → {{ monto($any(e).op.destino) }}</ng-container></div>
          <ol class="linea">
            <li *ngFor="let p of $any(e).pasos" [ngClass]="p.estado">
              <span class="punto" aria-hidden="true"></span>
              <span>
                <span class="paso">{{ p.titulo }}</span>
                <span class="detalle" *ngIf="p.detalle">{{ p.detalle }}</span>
              </span>
            </li>
          </ol>
        </div>

        <div *ngSwitchCase="'fondeos'" class="msg bot ancho">
          {{ $any(e).titulo }}
          <div class="filas">
            <ng-container *ngFor="let f of $any(e).lista">
              <button
                *ngIf="$any(e).paraOperador; else filaFondeo"
                type="button"
                class="fila tocable"
                (click)="tocarFondeo(f)"
              >
                <ng-container *ngTemplateOutlet="cuerpoFondeo; context: { $implicit: f }"></ng-container>
              </button>
              <ng-template #filaFondeo>
                <div class="fila">
                  <ng-container *ngTemplateOutlet="cuerpoFondeo; context: { $implicit: f }"></ng-container>
                </div>
              </ng-template>
            </ng-container>
          </div>
          <span class="meta" *ngIf="$any(e).paraOperador">Al tocarlo te abrimos WhatsApp con los datos ya escritos.</span>
        </div>

        <div *ngSwitchCase="'ultimoFondeo'" class="msg bot ancho">
          Tu último fondeo:
          <div class="filas">
            <div class="fila">
              <span class="ico"><mat-icon>south_west</mat-icon></span>
              <span class="cuerpo">
                <span class="t1">{{ $any(e).fondeo.medio }}</span>
                <span class="t2">{{ monto($any(e).fondeo.monto) }}</span>
                <span class="t3">{{ fecha($any(e).fondeo.fecha) }} · {{ $any(e).fondeo.referencia }}</span>
              </span>
              <span class="estado" [ngClass]="claseEstado($any(e).fondeo.estado)">{{ $any(e).fondeo.estadoTexto }}</span>
            </div>
          </div>
          <ol class="linea">
            <li *ngFor="let p of $any(e).pasos" [ngClass]="p.estado">
              <span class="punto" aria-hidden="true"></span>
              <span>
                <span class="paso">{{ p.titulo }}</span>
                <span class="detalle" *ngIf="p.detalle">{{ p.detalle }}</span>
              </span>
            </li>
          </ol>
        </div>

        <div *ngSwitchCase="'noVes'" class="msg bot ancho">
          Antes de escribirnos, revisa esto:
          <ul class="revisar">
            <li><mat-icon>check_circle</mat-icon>La transferencia salió desde una cuenta a tu nombre o de un pagador autorizado.</li>
            <li><mat-icon>account_balance</mat-icon>Transferiste a los datos de Recargar saldo.</li>
            <li><mat-icon>schedule</mat-icon>Pasaron al menos 30 minutos.</li>
          </ul>
          <div *ngIf="$any(e).ultimo as u">
            Tu último fondeo registrado: <b>{{ monto(u.monto) }}</b> del {{ fecha(u.fecha) }}, {{ u.estadoTexto | lowercase }}.
          </div>
          <div *ngIf="!$any(e).ultimo">Todavía no tenemos fondeos registrados a tu nombre.</div>
        </div>

        <div *ngSwitchCase="'tasa'" class="msg bot ancho">
          {{ $any(e).tasa.titulo }}, tasa de hoy:
          <div class="filas">
            <div class="fila tasa" *ngFor="let t of $any(e).tasa.tramos">
              <span class="ico"><mat-icon>trending_up</mat-icon></span>
              <span class="cuerpo">
                <span class="t3">{{ $any(e).tasa.unidad === 'CLP_POR_VES' ? 'Montos equivalentes a' : 'Montos de' }} {{ textoTramo(t.desde, t.hasta) }}</span>
                <span class="t1" *ngIf="t.tasa !== null">{{ textoTasa($any(e).tasa, t.tasa) }}</span>
                <span class="t1 sin-tasa" *ngIf="t.tasa === null">Actualizándose</span>
              </span>
            </div>
          </div>
          <span class="meta">
            <ng-container *ngIf="$any(e).consultadoEn">Consultada {{ fecha($any(e).consultadoEn) }}. </ng-container>
            La tasa final se confirma al crear la operación.
          </span>
        </div>

        <!-- Las mismas filas de la tarjeta "Tasas del día" del home. OJO con
             los rótulos del par USDT: `tasa` es a cuánto COMPRA el cliente y
             `venta` a cuánto VENDE (ver home-rates.component.html). -->
        <div *ngSwitchCase="'tasas'" class="msg bot ancho">
          Tasas de hoy:
          <ng-container *ngFor="let g of [
              { titulo: 'Enviar dinero', filas: $any(e).tasas.envios },
              { titulo: 'USDT', filas: $any(e).tasas.usdt }
            ]">
            <div class="grupo-tasas" *ngIf="g.filas.length">{{ g.titulo }}</div>
            <div class="filas" *ngIf="g.filas.length">
              <div class="fila tasa" *ngFor="let t of g.filas; trackBy: trackTasa">
                <span class="par" aria-hidden="true">
                  <img [src]="t.def.iconoOrigen" alt="" />
                  <img class="dst" [src]="t.def.iconoDestino" alt="" />
                </span>
                <span class="cuerpo">
                  <span class="t1">{{ t.def.nombre }}</span>

                  <ng-container *ngIf="t.tramos">
                    <span class="t3">{{ unidadTasa(t) }}</span>
                    <span class="t2" *ngFor="let tr of t.tramos">
                      Desde {{ tr.desde }}: {{ tr.tasa | number: t.def.decimales }} {{ t.def.simbolo }}<b *ngIf="tr.mejor"> · mejor</b>
                    </span>
                    <span class="t3" *ngIf="tramosAproximados(t)">Montos aproximados</span>
                  </ng-container>

                  <ng-container *ngIf="!t.tramos && esParTasa(t)">
                    <span class="t3">{{ t.def.simbolo }} {{ t.def.porLabel }}</span>
                    <span class="t2">Compras a {{ t.tasa | number: t.def.decimales }} · Vendes a {{ t.venta | number: t.def.decimales }}</span>
                    <!-- Tramos VES→USDT, aparte: sin ellos la fila queda igual que antes -->
                    <ng-container *ngIf="tramosUsdtTasa(t) as tus">
                      <span class="t3">Comprar USDT por tramo</span>
                      <span class="t2" *ngFor="let tr of tus">
                        {{ tr.rotulo }}: {{ tasaTramoUsdt(tr, t) }} {{ t.def.simbolo }}<b *ngIf="tr.mejor"> · mejor</b>
                      </span>
                    </ng-container>
                    <!-- Tramos USDT→VES (espejo): el mejor es la tasa más alta -->
                    <ng-container *ngIf="tramosUsdtVentaTasa(t) as tvs">
                      <span class="t3">Vender USDT por tramo</span>
                      <span class="t2" *ngFor="let tr of tvs">
                        {{ tr.rotulo }}: {{ tasaTramoUsdt(tr, t) }} {{ t.def.simbolo }}<b *ngIf="tr.mejor"> · mejor</b>
                      </span>
                    </ng-container>
                  </ng-container>

                  <span class="t2" *ngIf="!t.tramos && !esParTasa(t)">
                    {{ t.tasa | number: t.def.decimales }} {{ t.def.simbolo }} {{ t.def.porLabel }}
                  </span>
                </span>
              </div>
            </div>
          </ng-container>
          <span class="meta">
            <ng-container *ngIf="$any(e).consultadoEn">Actualizadas {{ fecha($any(e).consultadoEn) }}. </ng-container>
            La tasa final se confirma al crear la operación.
          </span>
        </div>

        <div *ngSwitchCase="'operador'" class="aviso-operador">
          <mat-icon>chat</mat-icon>
          <span>Te abrimos WhatsApp con un operador. El mensaje ya va escrito; sólo tienes que enviarlo.</span>
        </div>

        <div *ngSwitchCase="'error'" class="msg bot error">{{ $any(e).texto }}</div>

      </ng-container>
    </ng-container>

    <div class="escribiendo" *ngIf="escribiendo" aria-label="El asistente está buscando la información">
      <i></i><i></i><i></i>
    </div>
  </div>

  <div class="panel-inferior">
    <div class="opciones" *ngIf="mostrarMenu || opciones.length">
      <ng-container *ngIf="mostrarMenu">
        <div class="grupo" *ngFor="let g of grupos">
          <span class="grupo-titulo">{{ g.titulo }}</span>
          <div class="tiles">
            <button
              type="button"
              class="tile"
              *ngFor="let b of g.botones"
              [class.ancho]="b.ancho"
              [disabled]="ocupado"
              (click)="tocarBoton(b)"
            >
              <span class="ico"><mat-icon>{{ b.icono }}</mat-icon></span>
              <span>{{ b.texto }}</span>
            </button>
          </div>
        </div>
      </ng-container>

      <div class="tiles motivos" *ngIf="!mostrarMenu && conIcono.length">
        <button
          type="button"
          class="tile"
          *ngFor="let o of conIcono"
          [disabled]="ocupado && !o.operador"
          (click)="tocarOpcion(o)"
        >
          <span class="ico"><mat-icon>{{ o.icono }}</mat-icon></span>
          <span>{{ o.texto }}</span>
        </button>
      </div>

      <div class="chips" *ngIf="!mostrarMenu && sinIcono.length">
        <button
          type="button"
          class="chip"
          *ngFor="let o of sinIcono"
          [class.operador]="o.operador"
          [disabled]="ocupado && !o.operador"
          (click)="tocarOpcion(o)"
        >
          {{ o.texto }}
        </button>
      </div>
    </div>

    <div class="barra">
      <button type="button" class="menu" (click)="volverAlMenu()" [disabled]="ocupado">
        <mat-icon>menu</mat-icon>Menú
      </button>
      <button type="button" class="humano" (click)="hablarConOperador()">
        <mat-icon>chat</mat-icon>Hablar con un operador
      </button>
    </div>
    <p class="sin-texto">Este asistente funciona sólo con botones. Para otra consulta, habla con un operador.</p>
  </div>
</section>

<!-- Una fila de fondeo: la usan la lista de consulta y la de elegir operador. -->
<ng-template #cuerpoFondeo let-f>
  <span class="ico"><mat-icon>south_west</mat-icon></span>
  <span class="cuerpo">
    <span class="t1">{{ f.medio }}</span>
    <span class="t2">{{ monto(f.monto) }}</span>
    <span class="t3">{{ fecha(f.fecha) }} · {{ f.referencia }}</span>
  </span>
  <span class="estado" [ngClass]="claseEstado(f.estado)">{{ f.estadoTexto }}</span>
</ng-template>
